import React, { useCallback, useMemo } from 'react';
import { useRetrieveByEventNumber } from '../../store/event/eventActions';
import { useEntryStore } from '../../store/entry/entryStore';
import HorseCard from '../HorseCard/HorseCard';
import { useGetHorseInfo } from '../HorseCard/HorseCard.functions';
import { Selection } from '../../interfaces/sports';
import './EventSelectionWrapper.scss';

interface EventSelectionWrapperProps {
  eventNumber: number;
  onClick?: () => void;
}

const EventSelectionWrapper = ({ eventNumber, onClick }: EventSelectionWrapperProps) => {
  const event = useRetrieveByEventNumber(eventNumber);
  const pick = useEntryStore((s) => s?.picks)?.find((pick) => event?.eventId === pick.eventId);
  const setSelectedPick = useEntryStore((s) => s.setPick);
  const getHorseInfo = useGetHorseInfo();
  const market = event?.markets[0];

  const handleClick = useCallback(
    (selectionCode: string) => {
      if (!event) {
        console.error('handleClick - Event not found');
        return;
      }
      setSelectedPick({
        eventNumber,
        selectionCode,
        eventId: event.eventId,
        marketId: market?.marketId,
      });
      if (onClick) onClick();
    },
    [event, eventNumber, onClick, setSelectedPick, market?.marketId],
  );

  const cards = useMemo(() => {
    const buildCard = (participant: Selection) => {
      const horseInfo = getHorseInfo(participant);
      horseInfo.nonRunner = !participant.selectionActive;
      if (!participant.selectionActive) horseInfo.odds = 'NR';
      return (
        <HorseCard
          key={participant.selectionCode}
          state={participant.selectionCode === pick?.selectionCode && !horseInfo.nonRunner ? 'focused' : 'not-focused'}
          onClick={() => {
            handleClick(participant.selectionCode);
          }}
          horseInfo={horseInfo}
        />
      );
    };

    const active =
      market?.selections.filter((participant) => participant.selectionActive).map((s) => buildCard(s)) ?? [];

    const inactive =
      market?.selections.filter((participant) => !participant.selectionActive).map((s) => buildCard(s)) ?? [];

    return [...active, ...inactive];
  }, [getHorseInfo, handleClick, market?.selections, pick?.selectionCode]);
  return <div className={'event-selection-wrapper'}>{cards}</div>;
};
export default EventSelectionWrapper;
